/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort lines of text`)
};

const es_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordena líneas de texto`)
};

const de_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textzeilen sortieren`)
};

const nl_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorteer regels tekst`)
};

const fr_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier les lignes de texte`)
};

const it_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina le righe di testo`)
};

const pt_br2_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordene linhas de texto`)
};

const pt_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifique linhas de texto`)
};

const ja_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストの行をソート`)
};

const zh_ls_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对文本行排序`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_nav_main_desc", locale)
	if (locale === "en") return en_ls_nav_main_desc(inputs)
	if (locale === "es") return es_ls_nav_main_desc(inputs)
	if (locale === "de") return de_ls_nav_main_desc(inputs)
	if (locale === "nl") return nl_ls_nav_main_desc(inputs)
	if (locale === "fr") return fr_ls_nav_main_desc(inputs)
	if (locale === "it") return it_ls_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_ls_nav_main_desc(inputs)
	if (locale === "pt") return pt_ls_nav_main_desc(inputs)
	if (locale === "ja") return ja_ls_nav_main_desc(inputs)
	return zh_ls_nav_main_desc(inputs)
};